
import React from 'react';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { Control } from 'react-hook-form';
import { ContactFormValues } from '../ContactFormSchema';

interface MessageFieldProps {
  control: Control<ContactFormValues>;
}

const MessageField: React.FC<MessageFieldProps> = ({ control }) => {
  return (
    <FormField
      control={control}
      name="message"
      render={({ field }) => (
        <FormItem className="transition-all duration-300 hover:shadow-sm rounded-md group">
          <FormLabel className="block text-sm font-medium text-forti-fi-charcoal group-hover:text-forti-fi transition-colors">Your Message</FormLabel>
          <FormControl>
            <Textarea 
              placeholder="Enter your message" 
              rows={4} 
              className="mt-1 transition-all focus:ring-2 focus:ring-forti-fi/20"
              {...field}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default MessageField;
